/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @fileoverview Shared helpers for logic-layer fallback error messages via i18n.
 * @module utils/genericErrorMessages
 */
import i18n from "../i18n.js";

const GENERIC_ERROR_KEY_PREFIX = "errors.generic";

/**
 * Returns an API message when present; otherwise a translated generic fallback.
 *
 * @param {string|undefined|null} apiMessage
 * @param {string} [genericKey="SOMETHING_WENT_WRONG"]
 * @returns {string}
 */
export const apiMessageOrGeneric = (
  apiMessage,
  genericKey = "SOMETHING_WENT_WRONG",
) => apiMessage || i18n.t(`${GENERIC_ERROR_KEY_PREFIX}.${genericKey}`);

/**
 * Returns a translated generic error message.
 *
 * @param {string} genericKey
 * @param {Record<string, unknown>} [interpolation]
 * @returns {string}
 */
export const getGenericErrorMessage = (genericKey, interpolation) =>
  i18n.t(`${GENERIC_ERROR_KEY_PREFIX}.${genericKey}`, interpolation);
